import {
    glowImage1, glowImage2, glowImage3, glowImage4, glowImage5,
    glowImage6, glowImage7, glowImage8, glowImage9, welcomeCardGlowImage1,
    errorScreenGlowImage1, errorScreenGlowImage2, errorScreenGlowImage3, errorScreenGlowImage4
} from "../assets/glow-images";

export const apiConstants = {
    grantTypeKey: "grant_type",
    grantTypeValue: "client_credentials",
    scopeKey: "scope",
    scopeValue: "default",
    headerContentTypeKey: "Content-Type",
    headerContentTypeValue: "application/x-www-form-urlencoded",
    headerAuthorizationKey: "Authorization",
    tokenTypeBasic: "Basic ",
    tokenTypeBearer: "Bearer ",
    alightRequestHeader: "alightRequestHeader",
    authToken: "authToken",
    authTokenExpiry: "authTokenExpiry",
    personToken: "personToken",
    personTokenExpiry: "personTokenExpiry",
    personTokenHeaderKey: "alightPersonSessionToken",
    authTokenEndpoint: "oauth/token",
    personTokenEndpoint: "session/startSessionForPerson",
    aadToken: "aadToken",
    userEndpointKeyword: "/users"
};

export const errorLoggingConstants = {
    todoComponentFile: "to-dos.tsx",
    promotionsComponentFile: "home-tab.tsx",
    appComponentFile: "app.tsx",
    welcomeComponentFile: "welcome.tsx",
    initializeApp: "initialize app",
    useEffect: "useEffect",
    todosAPI: "todos API",
    promotionsAPI: "Promotions API",
    userDetailsAPI: "User Details API",
    userPhotosAPI: "User Photos API",
    apiInterceptorFile: "APIInterceptor.ts",
    authTokenAPI: "Auth token API",
    personTokenAPI: "person token API",
    teamsTokenAPI: "Teams token API",
    apiInterceptor: "API interceptor",
    personAccountSummaryAPI: "Person Account Summary API"
};

export const componentConstants = {
    todosTitle: "To-Dos",
    viewAllLinkText: "View All",
    todosEmptyResponseCardData: "Congratulations, you have completed your to-dos",
    recommendedTitle: "Recommended",
    recommendedEmptyResponseCardHeaderData: "Check back tomorrow for new recommendations",
    recommendedEmptyResponseCardBodyData: "You’re already ahead of the game, it’s time to relax.",
    accountSummary: "Account Summary",
    hideSensitiveInformation: "Hide Sensitive information",
    showSensitiveInformation: "Show Sensitive information",
    viewMoreAtAlightWorklife: "View more at Alight Worklife",
    linkHrefUrl: "https://www.alight.com/platform/alight-worklife",
    missingUsernameError: "Missing Name"
}

export const accountSummaryConstants = {
    hsa: "hsa",
    medical: "medical",
    pension: "pension",
    plan401k: "401k",
    greet: "Welcome back!",
}

export const toDosConstants = {
    due: "Due",
    siteLink: "Go to site"
}

export const errorConstants = {
    errorTextTitle: "We're having trouble loading this section.",
    errorTextSubtitle: "Please try again later or reload the page."
}

export const recommendationsGlowImagesConstants = {
    glowImage: [glowImage1, glowImage2, glowImage3, glowImage4, glowImage5,
        glowImage6, glowImage7, glowImage8, glowImage9],
}
export const welcomeCardGlowImagesConstants = {
    glowImage: [welcomeCardGlowImage1]
}
export const errorScreensGlowImagesConstants = {
    glowImage: [errorScreenGlowImage1, errorScreenGlowImage2, errorScreenGlowImage3, errorScreenGlowImage4],
}

export const _blank = "_blank";
export const cookieExpiry = 1/300; //cookie expiry for ~5 mins

export const appSupportedConstants = {
    browsers: ["edge", "chrome", "firefox", "safari"],
    os: ["windows", "os x", "android"],
    unsupportedBrowserTitle: "It looks like your browser is incompatible",
    unsupportedBrowserSubTitle: "Please use either Google Chrome, Mozilla Firefox, Microsoft Edge or Safari",
    appLevelErrorCodes: [400, 401, 403, 404, 500, 503],
    networkErrorText: "Network",
    networkErrorTitle: "We're having trouble contacting Alight right now.",
    networkErrorStatus: "Network error",
    timeoutErrorText: "timeout",
    timeoutErrorTitle: "It's taking longer than usual to hear back from Alight.",
    timeoutErrorSubTitle: "Your request has timed out, please try again later.",
    timeoutErrorStatus: "Timeout error",
    refreshButtonText: "Refresh Page",
    apifailedStatus: "500",
    apiSucessStatus: "200",
    customErrorMessageTitle: "We could not authenticate you right now.",
    refreshPageTextSubTitle: "Please refresh or try again later.",
    somethingWentWrong: "Something went wrong.",
    errorCodeText: "Error Code: "
};

